import React from 'react';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const DailyDashboardSkeleton = props => (
  <div className="dashboard-left-side-skeleton">
    <div className="dashboard-left-side-skeleton-rings">
      <Skeleton className="dashboard-left-side-skeleton-rings-circle1 dashboard-left-side-skeleton-rings_middle" circle />
      <div className="dashboard-left-side-skeleton-rings-white-box1 dashboard-left-side-skeleton-rings_box dashboard-left-side-skeleton-rings_middle" />
      <Skeleton className="dashboard-left-side-skeleton-rings-circle2 dashboard-left-side-skeleton-rings_middle" circle />
      <div className="dashboard-left-side-skeleton-rings-white-box2 dashboard-left-side-skeleton-rings_box dashboard-left-side-skeleton-rings_middle" />
      <Skeleton className="dashboard-left-side-skeleton-rings-circle3 dashboard-left-side-skeleton-rings_middle" circle />
      <div className="dashboard-left-side-skeleton-rings-white-box3 dashboard-left-side-skeleton-rings_box dashboard-left-side-skeleton-rings_middle" />
      <Skeleton className="dashboard-left-side-skeleton-rings-circle4 dashboard-left-side-skeleton-rings_middle" circle />
      <div className="dashboard-left-side-skeleton-rings-white-box4 dashboard-left-side-skeleton-rings_box dashboard-left-side-skeleton-rings_middle" />
    </div>
    <div>
      <Skeleton borderRadius="5rem" className="dashboard-left-side-skeleton-measure-header" />
      <span>
        {[...Array(3)].map((e, i) => (
          <div key={i}>
            <Skeleton borderRadius="5rem" className="dashboard-left-side-skeleton-measure-title" />
            <Skeleton borderRadius="5rem" className="dashboard-left-side-skeleton-measure-bar" />
          </div>
        ))}
      </span>

      <Skeleton borderRadius="5rem" className="dashboard-left-side-skeleton-measure-header" />
      <span>
        {[...Array(4)].map((e, i) => (
          <div key={i}>
            <Skeleton borderRadius="5rem" className="dashboard-left-side-skeleton-measure-title" />
            <Skeleton borderRadius="5rem" className="dashboard-left-side-skeleton-measure-bar" />
          </div>
        ))}
      </span>

      <Skeleton borderRadius="5rem" className="dashboard-left-side-skeleton-measure-header" />
      <span>
        {[...Array(2)].map((e, i) => (
          <div key={i}>
            <Skeleton borderRadius="5rem" className="dashboard-left-side-skeleton-measure-title" />
            <Skeleton borderRadius="5rem" className="dashboard-left-side-skeleton-measure-bar" />
          </div>
        ))}
      </span>

      <Skeleton borderRadius="5rem" className="dashboard-left-side-skeleton-measure-header" />
      <span>
        {[...Array(3)].map((e, i) => (
          <div key={i}>
            <Skeleton borderRadius="5rem" className="dashboard-left-side-skeleton-measure-title" />
            <Skeleton borderRadius="5rem" className="dashboard-left-side-skeleton-measure-bar" />
          </div>
        ))}
      </span>
    </div>

  </div>
);
export default DailyDashboardSkeleton;
